import React from "react";

import { Link, useParams, useNavigate } from "react-router-dom";
import { use, useContext, useState } from "react";
import { DataHandlerContext } from "../../providers/DataHandlerProvider";
import TopTitle from "../buttons/TopTitle";

function AddEvents() {
  const { eventseriesid } = useParams();
  const { handleAddEvent, errorSubmit, loadingSubmit } =
    useContext(DataHandlerContext);
  const [storeInput, setStoreInput] = useState({});

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setStoreInput((prev) => {
      if (type === "number") {
        return {
          ...prev,
          [name]: value ? Number(value) : 0,
        };
      }

      if (type === "checkbox") {
        return {
          ...prev,
          [name]: checked,
        };
      }

      if (type === "datetime-local") {
        return {
          ...prev,
          [name]: new Date(value).toISOString(),
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !storeInput.event_title ||
      !storeInput.google_calendar_id ||
      !storeInput.date
    ) {
      alert("Please fill in all required fields");
      return;
    }

    try {
      const response = await handleAddEvent(eventseriesid, storeInput);
      if (response.status === 200) {
        console.log("Event added successfully");
        navigate(-1);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };
  return (
    <div className="flex flex-col h-screen ">
      <div className="  flex justify-center  mt-8   ">
        {errorSubmit && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
            role="alert"
          >
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">
              Error adding event. Please try again.
            </span>
          </div>
        )}
      </div>
      <TopTitle title="Add an event" />

      <div className="flex justify-between md:px-[20rem]   py-10 items-center md:space-x-4">
        <input
          onChange={(e) => handleInputChange(e)}
          value={storeInput.event_title || ""}
          name="event_title"
          type="text"
          placeholder="Enter event title"
          className="text-5xl font-extrabold border w-full border-black px-4 py-2"
          required
        />
      </div>

      <div className=" md:px-[20rem]  items-center md:space-x-4">
        <form className="flex flex-col ">
          <label className="border-[2px]  px-4 py-2 mt-4 border-black ">
            Event settings
          </label>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1">Show on Slack</label>
            <input
              value={storeInput.show_on_slack || ""}
              onChange={(e) => handleInputChange(e)}
              name="show_on_slack"
              className=" px-4 py-3 mt-4 border-[2px] border-black w-full flex-1 appearance-none bg-gray-100 rounded-full checked:bg-green-300 cursor-pointer transition-colors duration-300"
              type="checkbox"
            />
          </div>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1">
              Google Calendar ID:{" "}
              <span className="text-2xl text-red-400">*</span>
            </label>
            <input
              value={storeInput.google_calendar_id || ""}
              onChange={(e) => handleInputChange(e)}
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="text"
              name="google_calendar_id"
              placeholder="Enter Google Calendar ID"
              required
            />
          </div>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1">
              Target Participants:
            </label>
            <input
              value={storeInput.target_participants || ""}
              onChange={(e) => handleInputChange(e)}
              name="target_participants"
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="number"
              placeholder="Enter target participants"
            />
          </div>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1">
              Maximum Participants:
            </label>
            <input
              value={storeInput.maximum_participants || ""}
              onChange={(e) => handleInputChange(e)}
              name="maximum_participants"
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="number"
              placeholder="Enter maximum participants"
            />
          </div>

          <div className="flex items-center">
            <label className=" px-4 py-2 mt-4 flex-1">
              Date: <span className="text-2xl text-red-400">*</span>
            </label>
            <input
              onChange={(e) => handleInputChange(e)}
              name="date"
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="datetime-local"
              placeholder="Enter date"
              required
            />
          </div>

          <button
            onClick={(e) => {
              handleSubmit(e);
            }}
            className="border-[2px] bg-white sticky bottom-0 border-black px-4 py-2 mt-4  text-black "
          >
            {loadingSubmit ? "Adding Event" : "Add Event"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddEvents;
